import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class EngineeringCoursesDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
          <h4>University of Madras</h4><br/>
				  <p>“Advance your career with MIET's flexible MBA courses in Chennai”</p><br/><br/>
          <h4>UG / PG correspondence courses in Chennai.</h4><br/>
          <p>University of Madras: A Public State University which is ranked in the Best Global Universities list and stands prestigious in Chennai. MIET <b> PG correspondence courses in Chennai </b> help you to crack the distance education courses offered by this University.</p><br/>
          <p>MIET's <b> MBA courses in chennai madras university </b> are designed to equip students with the skills and knowledge they need to succeed in the competitive business world. Madras University ensures a high-quality education that is recognized both nationally and internationally.</p><br/>
          <p>Whether you are looking to enhance your current skills or learn something new, MIET’s <b> UG correspondence courses in Chennai </b> offer flexibility and quality education without sacrificing convenience.</p><br/>
          <p>Want to enhance your career opportunities but don't have the time for full-time courses? MIET offers flexible and affordable correspondence courses for both <b> UG and PG correspondence courses in Chennai.</b> Enroll now and take the first step towards your dream career!</p><br/>
          <p>Visit our website to learn more and enrol today!</p>
          </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
					   <h4>Bharathidasan University</h4><br/>
              <p>Bharathidasan University: A University known for its heritage, was established in the year 1982 in Tiruchirapalli with a strong motto to create a brave world. MIET, <b> MBA correspondence in Chennai</b> provides the right knowledge and easy ways to crack exams smartly.</p><br/>
              <p>MIET offers a comprehensive <b> MBA distance education in Chennai,</b> designed for working professionals who want to upskill themselves and achieve career advancement. Our courses are tailored to meet the ever-changing demands of the industry.</p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight"><br/>
                      <h4>Tamil Nadu Open University</h4><br/>
                       <p>Tamil Nadu Open University: The University established in the year 2002 and based in Chennai is meant for Open and distance learning providing a purpose to spread education to everyone. With MIET <b>MBA distance education in Chennai</b> and its rich materials, you could be well-equipped to succeed in overcoming the course.</p><br/>
                        <p>MIET's <b> MBA courses in Chennai correspondence </b> are designed to fit into your busy schedule, offering both online and correspondence options. Take the next step towards your professional goals with our comprehensive programs.</p>
                    </ScrollAnimation>

                    
                  </div>
		      </div>
			  <Sidebar courseRestriction="Distance Education" />
		    </div>
		  </div>
		</div>

        }
}

export default EngineeringCoursesDetails